import { App } from "vue";
import { WhiteLabelService } from "@/core/services/WhiteLabelService";

/**
 * Initialize VueApexChart component
 * @param app vue instance
 */
export function initWhiteLabelTheme(app: App<Element>) {
  WhiteLabelService.instantiate().catch(console.error);
}
